import { Directive, ElementRef, NgZone, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appResizeObserver]',
  standalone: true
})
export class ResizeObserverDirective implements OnInit, OnDestroy {
  private resizeObserver!: ResizeObserver;

  @Output() widthChanged = new EventEmitter<number>();

  constructor(private el: ElementRef, private ngZone: NgZone) {}

  ngOnInit() {
    this.resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        const newWidth = entry.contentRect.width;
        this.ngZone.run(() => this.widthChanged.emit(newWidth)); // Run inside Angular zone
      }
    });

    this.resizeObserver.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.resizeObserver.disconnect();
  }
}
